export const organisationTypes = [
    "Non-Governmental Organisation (NGO)",
    "Civil Society Organisation (CSO)",
    "Community-Based Organisation (CBO)",
    "International NGO",
    "Research Institution",
    "Academic Institution",
    "Private Sector",
    "Government Agency",
    "Other",
];

export const staffSizeOptions = [
    { value: "0", label: "0 (No staff)" },
    { value: "1-3", label: "1-3 (Micro)" },
    { value: "4-10", label: "4-10 (Small)" },
    { value: "11-25", label: "11-25 (Medium)" },
    { value: "26-50", label: "26-50 (Large)" },
    { value: "51-100", label: "51-100 (Very Large)" },
    { value: "100+", label: "100+ (Enterprise)" },
];

export const volunteerSizeOptions = [
    { value: "0", label: "0 (No volunteers)" },
    { value: "1-5", label: "1-5 (Small)" },
    { value: "6-15", label: "6-15 (Medium)" },
    { value: "16-30", label: "16-30 (Large)" },
    { value: "31-50", label: "31-50 (Very Large)" },
    { value: "50+", label: "50+ (Massive)" },
];

export const socialMediaPlatforms = [
    "Facebook",
    "Instagram",
    "X (Twitter)",
    "LinkedIn",
    "YouTube",
    "TikTok",
];

export const missionFields = [
    "Education",
    "Healthcare",
    "Environment",
    "Human Rights",
    "Gender Equality",
    "Economic Development",
    "Agriculture",
    "Youth Development",
    "Disability Rights",
    "Refugee Support",
    "Climate Change",
    "Digital Innovation",
    "Cultural Heritage",
    "Peace Building",
    "Other",
];

export const thematicAreas = [
    "Education & Skills Development",
    "Health & Wellbeing",
    "Environmental Protection",
    "Economic Empowerment",
    "Social Inclusion",
    "Digital Transformation",
    "Cultural Exchange",
    "Youth Engagement",
    "Gender Equality",
    "Climate Action",
    "Humanitarian Aid",
    "Research & Innovation",
    "Other",
];

export const countries = [
    "Albania",
    "Bosnia and Herzegovina",
    "Kosovo",
    "Montenegro",
    "North Macedonia",
    "Serbia",
    "Other",
];

export const preferredRoles = [
    "Lead",
    "Partner",
    "Either",
];

export const expertiseTypes = [
    "Project Management",
    "Technical Expertise",
    "Financial Management",
    "Capacity Building",
    "Research & Analysis",
    "Advocacy & Policy",
    "Community Engagement",
    "Digital Skills",
    "Monitoring & Evaluation",
    "Grant Writing",
    "Partnership Development",
    "Training & Education",
    "Environmental Protection",
    "Healthcare Services",
    "Youth Development",
    "Gender Mainstreaming",
    "Disability Inclusion",
    "Refugee Support",
    "Cultural Heritage",
    "Other",
];

export const availableResources = [
    "Financial Resources",
    "Technical Equipment",
    "Office Space",
    "Transportation",
    "Expert Staff",
    "Volunteer Network",
    "Local Partnerships",
    "Research Facilities",
    "Training Materials",
    "Digital Platforms",
    "Media Resources",
    "Legal Support",
    "Translation Services",
    "Other",
];

export const keywords = [
    "Youth Empowerment",
    "Digital Skills",
    "Environmental Protection",
    "Social Inclusion",
    "Gender Equality",
    "Education",
    "Healthcare",
    "Economic Development",
    "Cultural Heritage",
    "Climate Action",
    "Human Rights",
    "Community Development",
    "Innovation",
    "Sustainability",
    "Capacity Building",
    "Advocacy",
    "Research",
    "Training",
    "Partnership",
    "Other",
]; 
